
import { Vue, Component } from "vue-property-decorator";
import store from "@/store";

const settingJa = {
  link: `/pages/2024mghrec2`,
  text: `【必ずチェック・お得！】<br>MGH Rewards Clubの<br class="pc">会員登録`
}

const settingEn = {
  link: `/en/pages/2024mghrec2`,
  text: `Let's link your MGH Rewards Club Account`
}

@Component
export default class ButtonRewardsClub extends Vue {
  get lang(): string {
    return this.$store.getters["auth/lang"];
  }

  get word() {
    if (this.lang === "ja") {
      return settingJa;
    }
    return settingEn;
  }


  get showRewardsClubButton(): boolean {
    if (!store.getters["auth/group"]) {
      return false;
    }
    const whiteList = process.env.VUE_APP_SHOW_REWARDS_CLUB_BUTTON_WHITE_LIST.split(",") || [];
    return whiteList.includes(store.getters["auth/group"]);
  }

}
